import { useInView } from '@/hooks/useInView'

interface SectionProps {
  children: React.ReactNode
  className?: string
  delay?: string
}

export default function Section({ children, className = '', delay }: SectionProps) {
  const [ref, visible] = useInView(0.1)

  return (
    <section
      ref={ref as React.RefObject<HTMLElement>}
      className={`section-animate ${className}`}
      style={{
        opacity: visible ? 1 : 0,
        transform: visible ? 'translateY(0)' : 'translateY(32px)',
        transitionDelay: delay || '0s',
      }}
    >
      {children}
    </section>
  )
}
